import * as React from "react";
import { twMerge } from "tailwind-merge";
export default function Renderer(props) {
    const className = twMerge("slider", props.className);
    return (React.createElement("input", { className: className, type: "range", name: props.name, min: props.min, max: props.max, value: props.value, step: props.step, disabled: props.disabled, style: { width: props.width }, "data-orientation": props.orientation, onChange: props.onChange, onMouseUp: props.onMouseUp, onTouchEnd: props.onTouchEnd }));
}
//# sourceMappingURL=renderer.js.map